var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("div", { staticClass: "bc_ico" }, [
          _c(
            "a",
            { attrs: { href: "JavaScript:" }, on: { click: _vm.goMain } },
            [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.PAGEINFO.HOME")))]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" " + _vm._s(_vm.$t("TITLE.SEARCH.RESULTS")) + "\n        ")
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [
          _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.RESULTS")))
        ]),
        _vm._v(" "),
        _c(
          "keep-alive",
          [
            _c("base-search-area", {
              attrs: {
                bToggle: true,
                isSearching: _vm.isSearching,
                pKeyword: _vm.keyword,
                topClass: "srchTop_wrap srchResult_wrap",
                callSearchFunc: _vm.callSearchFunc
              },
              on: { "search-toggle": _vm.toggleSearching }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "result_wrap" }, [
          _vm.relatedSearchWords && _vm.relatedSearchWords.length > 0
            ? _c("dl", { staticClass: "related_keywords" }, [
                _c("dt", [
                  _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.RELATED.KWORD")))
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c(
                    "ul",
                    _vm._l(_vm.relatedSearchWords, function(rel) {
                      return _c("li", { key: rel.sympDesc }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "JavaScript:" },
                            on: {
                              click: function($event) {
                                return _vm.clickRelSearchWord(rel)
                              }
                            }
                          },
                          [_vm._v(_vm._s(rel.sympDesc))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "refine" }, [
            _c("em", [_vm._v(_vm._s(_vm.$t("TITLE.SEARCH.RESULT.FOR")))]),
            _vm._v(" '" + _vm._s(_vm.params.keyword) + "'")
          ]),
          _vm._v(" "),
          _vm.params.searchKind != "K"
            ? _c(
                "section",
                {
                  class: { active: _vm.toggle1 },
                  attrs: { "data-type": "quick" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "result_title",
                      on: {
                        click: function($event) {
                          _vm.toggle1 = !_vm.toggle1
                        }
                      }
                    },
                    [
                      _c("em", [
                        _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.QUICK.DOWNLOAD")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.toggle1
                    ? _c("div", { staticClass: "result_con" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm.quickDownloads.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "table_modul table_scroll pc_only"
                              },
                              [
                                _c("table", { staticClass: "data_table_ty2" }, [
                                  _c(
                                    "colgroup",
                                    [
                                      _c("col", { attrs: { width: "155px" } }),
                                      _vm._v(" "),
                                      _vm._l(_vm.columns, function(col) {
                                        return _c("col", {
                                          key: col.boardId,
                                          attrs: { width: "140px" }
                                        })
                                      }),
                                      _vm._v(" "),
                                      _c("col", { attrs: { width: "140px" } })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FIELD.SEARCH.MODELS")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(_vm.columns, function(col) {
                                          return _c(
                                            "th",
                                            {
                                              key: col.boardId,
                                              attrs: { align: "center" }
                                            },
                                            [_vm._v(_vm._s(col.headerNm))]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(_vm.$t("FIELD.SEARCH.BOM"))
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.quickDownloads, function(data) {
                                      return _c(
                                        "tr",
                                        { key: data.BMODEL_ID },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "text_center" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "JavaScript:" }
                                                },
                                                [
                                                  _c(
                                                    "em",
                                                    {
                                                      staticClass: "txt_point",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickQcModel(
                                                            data.BMODEL_ID
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(data.BMODEL_ID)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(data.subValues, function(sub) {
                                            return _c(
                                              "td",
                                              {
                                                key: sub.ID,
                                                staticClass: "text_center"
                                              },
                                              [
                                                sub.headId == "CNT_EXPVP"
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "JavaScript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.viewAttachFiles(
                                                              $event,
                                                              data,
                                                              sub.headId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "em",
                                                          {
                                                            staticClass:
                                                              "txt_point"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(sub.cntSum)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                sub.headId != "CNT_EXPVP" &&
                                                sub.cntSum > 0 &&
                                                sub.headId != "CNT_3DEXPVW"
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "JavaScript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.fileDownload(
                                                              sub.nIndex,
                                                              data
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "em",
                                                          {
                                                            staticClass:
                                                              "txt_point"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(sub.cntSum)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                sub.headId != "CNT_EXPVP" &&
                                                sub.cntSum == 0 &&
                                                sub.headId != "CNT_3DEXPVW"
                                                  ? _c("span", [
                                                      _vm._v(_vm._s(sub.cntSum))
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text_center" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "ico_attach",
                                                  attrs: {
                                                    href: "JavaScript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.popupBomOpen(
                                                        data
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr_only" },
                                                    [_vm._v("attach")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.quickDownloads.length > 0
                          ? _c(
                              "div",
                              { staticClass: "table_modul tabmobile_only" },
                              [
                                _c("table", { staticClass: "data_table_ty2" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "select_th",
                                          attrs: { colspan: "2" }
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selModelCd,
                                                  expression: "selModelCd"
                                                }
                                              ],
                                              staticClass: "slt_white w100p",
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.selModelCd = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                  function($event) {
                                                    return _vm.changeQdnModel()
                                                  }
                                                ]
                                              }
                                            },
                                            _vm._l(_vm.quickDownloads, function(
                                              model
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: model.BMODEL_ID,
                                                  domProps: {
                                                    value: model.BMODEL_ID
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(model.BMODEL_ID)
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(_vm.selModels, function(sub) {
                                        return _c("tr", { key: sub.ID }, [
                                          _c("td", [
                                            _vm._v(_vm._s(sub.headNm))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text_center" },
                                            [
                                              sub.headId == "CNT_EXPVP"
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "JavaScript:"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.viewAttachFiles(
                                                            $event,
                                                            {
                                                              BMODEL_ID:
                                                                _vm.selModelCd
                                                            },
                                                            sub.headId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "em",
                                                        {
                                                          staticClass:
                                                            "txt_point"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(sub.cntSum)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              sub.headId != "CNT_EXPVP" &&
                                              sub.cntSum > 0 &&
                                              sub.headId != "CNT_3DEXPVW"
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "JavaScript:"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.fileDownload(
                                                            sub.nIndex,
                                                            {
                                                              BMODEL_ID:
                                                                _vm.selModelCd
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "em",
                                                        {
                                                          staticClass:
                                                            "txt_point"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(sub.cntSum)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              sub.headId != "CNT_EXPVP" &&
                                              sub.cntSum == 0 &&
                                              sub.headId != "CNT_3DEXPVW"
                                                ? _c("span", [
                                                    _vm._v(_vm._s(sub.cntSum))
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _vm.selModelCd
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("FIELD.SEARCH.BOM")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text_center" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "ico_attach",
                                                    attrs: {
                                                      href: "JavaScript:"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.popupBomOpen(
                                                          {
                                                            BMODEL_ID:
                                                              _vm.selModelCd
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [_vm._v("attach")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.qcdnAttachFiles.length > 0
                          ? _c(
                              "div",
                              { staticClass: "table_modul gridDown_wrap" },
                              [
                                _c("div", { staticClass: "gridtop_wrap" }, [
                                  _c("em", { staticClass: "txt_info" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("MESSAGE.SEARCH.REQ.EXPLORER")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(3)
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "data_table_ty3" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.MODEL"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.VERSION"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "pc_only" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.SEARCH.WEB.VIEW")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.SEARCH.PDF"))
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    { staticClass: "text_center" },
                                    _vm._l(_vm.qcdnAttachFiles, function(file) {
                                      return _c("tr", { key: file.VERSION }, [
                                        _c("td", [
                                          _vm._v(_vm._s(file.MODEL_CD))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(file.VERSION))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "pc_only" }, [
                                          file.BOM_FILE_NAME
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "JavaScript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.popupHtmlOpen(
                                                        file
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BUTTON.SEARCH.CLICK"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "txt_link",
                                              attrs: {
                                                href:
                                                  "http://downloadcenter.samsung.com/content/" +
                                                  file.PDF_PATH,
                                                target: "_blank"
                                              }
                                            },
                                            [_vm._v(_vm._s(file.PDF_FILE_NAME))]
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.quickDownloads && _vm.quickDownloads.length > 0
                          ? _c("div", { staticClass: "btn_wrap" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "btn_laodmore",
                                  attrs: { href: "JavaScript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadMoreSearch()
                                    }
                                  }
                                },
                                [
                                  _vm._v(_vm._s(_vm.qcdnMoreMsg) + " "),
                                  _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.quickDownloads.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.qcdnTotalCount) + ")"
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.qcdnTotalCount == 0
                          ? _c("ul", { staticClass: "nodata_list" }, [
                              _c("li", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA"))
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            {
              class: { active: _vm.toggle2 },
              attrs: { "data-type": "engineer" }
            },
            [
              _c("div", { staticClass: "result_title" }, [
                _c("div", { staticClass: "sort_wrap" }, [
                  _c(
                    "a",
                    {
                      class: { active: _vm.sortBy == "rank" },
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.searchSortBy("rank")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.FAST.RELEVANCY")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: { active: _vm.sortBy == "regdate" },
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.searchSortBy("regdate")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("TITLE.SEARCH.LATEST")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "em",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle2 = !_vm.toggle2
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("TITLE.SEARCH.ENGINEER")))]
                )
              ]),
              _vm._v(" "),
              _vm.toggle2
                ? _c("div", { staticClass: "result_con" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "knowledge_list" },
                      _vm._l(_vm.engrContents, function(cont) {
                        return _c("li", { key: cont.keyId }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetailInfo($event, cont)
                                }
                              }
                            },
                            [
                              cont.iconType
                                ? _c(
                                    "em",
                                    { class: _vm.getIconClass(cont.iconType) },
                                    [_vm._v(_vm._s(cont.iconType))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.IMPORTANCE_YN == "Y"
                                ? _c(
                                    "em",
                                    { staticClass: "textcolor_important" },
                                    [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                          ) +
                                          "]"
                                      )
                                    ]
                                  )
                                : cont.MUST_READ_YN == "Y"
                                ? _c("em", { staticClass: "textcolor_must" }, [
                                    _vm._v(
                                      "[" +
                                        _vm._s(
                                          _vm.$t("FIELD.GLOBAL.MUSTREAD")
                                        ) +
                                        "]"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("em", {
                                domProps: { innerHTML: _vm._s(cont.subject) }
                              }),
                              _vm._v(" "),
                              _c("em", { staticClass: "info_modifi" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(cont.corpName) +
                                    ", " +
                                    _vm._s(cont.regDate) +
                                    ")"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon_item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "ico_favorite",
                                class: { off: !cont.isFavorite },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "F")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.FAVOR"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("BUTTON.FAST.FAVORITE")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "ico_like",
                                class: { off: !cont.isLike },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "L")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.LIKE"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.LIKE")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "info" }, [
                            _c("em", [_vm._v(_vm._s(cont.dispName))]),
                            _vm._v(" "),
                            _c("em", [_vm._v(_vm._s(cont.prodCd2))]),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.FAST.MODEL")) +
                                  " " +
                                  _vm._s(cont.modelNm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "hit" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.HIT"))),
                              _c("i", [_vm._v(_vm._s(cont.hitCnt))])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "view_desc" },
                            [
                              _c(
                                "table",
                                { staticClass: "data_table_ty2 mb-20" },
                                [
                                  _vm._m(6, true),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.REGISTERED.BY")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.REG_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.REG_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.MODIFY.USER")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.MODF_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.MODF_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.symptomList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.symptomList, function(
                                                symptom
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(symptom.NAME)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FIELD.KNOWLEDGE.MANUFACTURE"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.serialList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.serialList, function(
                                                serial
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(
                                                          serial.SERIAL_S
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            serial.SERIAL_E
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.GUIDETYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getGuideTypeName))
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getDefectTypeName))
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tab_wrap" }, [
                                _c(
                                  "ul",
                                  { staticClass: "tab_menu_02 tab_menus" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "on",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.DESCRIPTION"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.MODEL.LIST"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.PARTSLISTS"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.VERHISTORY"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "tab_contents" }, [
                                  _c("div", {
                                    staticClass: "tab_cont",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.KNOWLEDGE_DESC)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.resultCount < 999
                                    ? _c("div", { staticClass: "grid_total" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) +
                                            " : "
                                        ),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberFormat")(
                                                _vm.resultCount
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.modelGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.modelGridId + cont.keyId,
                                          data: _vm.modelList,
                                          columns: _vm.modelColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.partsGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.partsGridId + cont.keyId,
                                          data: _vm.partsList,
                                          columns: _vm.partsColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab_cont" }, [
                                    _c("table", { staticClass: "data_table" }, [
                                      _vm._m(7, true),
                                      _vm._v(" "),
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.VERSION"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("FIELD.GLOBAL.DATE")
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.EDITOR"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.DETAILS"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        { staticClass: "text_center" },
                                        _vm._l(_vm.versionList, function(
                                          version
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: version.VERSION_NO },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  "Ver." +
                                                    _vm._s(version.VERSION_NO)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_DT)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_USER)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text_left" },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        version.MODF_REASON
                                                      ) +
                                                      "\n                                                         "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.contAttaches &&
                              _vm.contAttaches.length > 0 &&
                              cont.active == cont.keyId
                                ? _c("innorix-download", {
                                    attrs: {
                                      uploadId: _vm.uploadId + cont.keyId,
                                      serviceType: _vm.serviceType,
                                      attachList: _vm.contAttaches,
                                      fixWidth: _vm.irxWidth
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.contAttaches.length > 0
                                ? _c("dl", { staticClass: "attachment_link" }, [
                                    _c("dt", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.contAttaches, function(
                                          file
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                file.ENC_ATTCH_FILE_SEQ +
                                                file.ENC_TOKEN
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownloadUrl(
                                                        file.ENC_ATTCH_FILE_SEQ,
                                                        file.ENC_TOKEN
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "ico_attach"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(file.FILE_NM) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btn_wrap text_center mt-40 pc_only"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn_white_ico",
                                      attrs: { href: "JavaScript:", title: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.btnPrint(
                                            _vm.detail.KNOWLEDGE_ID
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "ico_printer on"
                                      }),
                                      _vm._v("Print")
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.engrTotalCount > 0
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_laodmore",
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.loadMoreCont(
                                    30,
                                    _vm.engrTotalCount
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.engrMoreMsg) +
                                  "\n                            "
                              ),
                              _vm.engrTotalCount > 0
                                ? _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.engrContents.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.engrTotalCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.engrTotalCount == 0
                      ? _c("ul", { staticClass: "nodata_list" }, [
                          _c("li", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              class: { active: _vm.toggle3 },
              attrs: { "data-type": "customer" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "result_title",
                  on: {
                    click: function($event) {
                      _vm.toggle3 = !_vm.toggle3
                    }
                  }
                },
                [_c("em", [_vm._v(_vm._s(_vm.$t("TITLE.SEARCH.CUSTOMER")))])]
              ),
              _vm._v(" "),
              _vm.toggle3
                ? _c("div", { staticClass: "result_con" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "knowledge_list" },
                      _vm._l(_vm.custContents, function(cont) {
                        return _c("li", { key: cont.keyId }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetailInfo($event, cont)
                                }
                              }
                            },
                            [
                              cont.iconType
                                ? _c(
                                    "em",
                                    { class: _vm.getIconClass(cont.iconType) },
                                    [_vm._v(_vm._s(cont.iconType))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.IMPORTANCE_YN == "Y"
                                ? _c(
                                    "em",
                                    { staticClass: "textcolor_important" },
                                    [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                          ) +
                                          "]"
                                      )
                                    ]
                                  )
                                : cont.MUST_READ_YN == "Y"
                                ? _c("em", { staticClass: "textcolor_must" }, [
                                    _vm._v(
                                      "[" +
                                        _vm._s(
                                          _vm.$t("FIELD.GLOBAL.MUSTREAD")
                                        ) +
                                        "]"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("em", {
                                domProps: { innerHTML: _vm._s(cont.subject) }
                              }),
                              _vm._v(" "),
                              _c("em", { staticClass: "info_modifi" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(cont.corpName) +
                                    ", " +
                                    _vm._s(cont.regDate) +
                                    ")"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon_item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "ico_favorite",
                                class: { off: !cont.isFavorite },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "F")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.FAVOR"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("BUTTON.FAST.FAVORITE")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "ico_like",
                                class: { off: !cont.isLike },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "L")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.LIKE"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.LIKE")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "info" }, [
                            _c("em", [_vm._v(_vm._s(cont.dispName))]),
                            _vm._v(" "),
                            _c("em", [_vm._v(_vm._s(cont.prodCd2))]),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.FAST.MODEL")) +
                                  " " +
                                  _vm._s(cont.modelNm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "hit" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.HIT"))),
                              _c("i", [_vm._v(_vm._s(cont.hitCnt))])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "view_desc" },
                            [
                              _c(
                                "table",
                                { staticClass: "data_table_ty2 mb-20" },
                                [
                                  _vm._m(9, true),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.REGISTERED.BY")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.REG_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.REG_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.MODIFY.USER")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.MODF_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.MODF_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.symptomList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.symptomList, function(
                                                symptom
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(symptom.NAME)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FIELD.KNOWLEDGE.MANUFACTURE"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.serialList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.serialList, function(
                                                serial
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(
                                                          serial.SERIAL_S
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            serial.SERIAL_E
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.GUIDETYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getGuideTypeName))
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getDefectTypeName))
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tab_wrap" }, [
                                _c(
                                  "ul",
                                  { staticClass: "tab_menu_02 tab_menus" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "on",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.DESCRIPTION"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.MODEL.LIST"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.PARTSLISTS"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.VERHISTORY"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "tab_contents" }, [
                                  _c("div", {
                                    staticClass: "tab_cont",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.KNOWLEDGE_DESC)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.resultCount < 999
                                    ? _c("div", { staticClass: "grid_total" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) +
                                            " : "
                                        ),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberFormat")(
                                                _vm.resultCount
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.modelGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.modelGridId + cont.keyId,
                                          data: _vm.modelList,
                                          columns: _vm.modelColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.partsGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.partsGridId + cont.keyId,
                                          data: _vm.partsList,
                                          columns: _vm.partsColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab_cont" }, [
                                    _c("table", { staticClass: "data_table" }, [
                                      _vm._m(10, true),
                                      _vm._v(" "),
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.VERSION"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("FIELD.GLOBAL.DATE")
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.EDITOR"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.DETAILS"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        { staticClass: "text_center" },
                                        _vm._l(_vm.versionList, function(
                                          version
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: version.VERSION_NO },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  "Ver." +
                                                    _vm._s(version.VERSION_NO)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_DT)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_USER)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text_left" },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        version.MODF_REASON
                                                      ) +
                                                      "\n                                                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.contAttaches &&
                              _vm.contAttaches.length > 0 &&
                              cont.active == cont.keyId
                                ? _c("innorix-download", {
                                    attrs: {
                                      uploadId: _vm.uploadId + cont.keyId,
                                      serviceType: _vm.serviceType,
                                      attachList: _vm.contAttaches,
                                      fixWidth: _vm.irxWidth
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.contAttaches.length > 0
                                ? _c("dl", { staticClass: "attachment_link" }, [
                                    _c("dt", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.contAttaches, function(
                                          file
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                file.ENC_ATTCH_FILE_SEQ +
                                                file.ENC_TOKEN
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownloadUrl(
                                                        file.ENC_ATTCH_FILE_SEQ,
                                                        file.ENC_TOKEN
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "ico_attach"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(file.FILE_NM) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btn_wrap text_center mt-40 pc_only"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn_white_ico",
                                      attrs: { href: "JavaScript:", title: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.btnPrint(
                                            _vm.detail.KNOWLEDGE_ID
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "ico_printer on"
                                      }),
                                      _vm._v("Print")
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.custTotalCount > 0
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_laodmore",
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.loadMoreCont(
                                    40,
                                    _vm.custTotalCount
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.custMoreMsg) +
                                  "\n                            "
                              ),
                              _vm.custTotalCount > 0
                                ? _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.custContents.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.custTotalCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.custTotalCount == 0
                      ? _c("ul", { staticClass: "nodata_list" }, [
                          _c("li", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              class: { active: _vm.toggle7 },
              attrs: { "data-type": "customer" }
            },
            [
              _c("div", { staticClass: "result_title samsung_title" }, [
                _c(
                  "div",
                  { staticClass: "sort_wrap" },
                  _vm._l(_vm.dotcomNations, function(nation) {
                    return _c(
                      "a",
                      {
                        key: nation.SITE_CD,
                        attrs: { href: "JavaScript:" },
                        on: {
                          click: function($event) {
                            return _vm.reloadSamsungDotcom(
                              $event,
                              nation.SITE_CD
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(nation.SITE_NM) +
                            " (" +
                            _vm._s(nation.SITE_CD) +
                            ")"
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "em",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle7 = !_vm.toggle7
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Samsung.com " + _vm._s(_vm.$t("TITLE.LEFT.MENU.SUPPORT"))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "result_con" }, [
                _vm._m(11),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "knowledge_list" },
                  _vm._l(_vm.dtcmContents, function(cont) {
                    return _c("li", { key: cont.familyRecord }, [
                      _c(
                        "a",
                        { attrs: { href: cont.linkUrl, target: "_blank" } },
                        [
                          _vm._v(
                            "[" +
                              _vm._s(cont.siteType) +
                              "] " +
                              _vm._s(cont.scTitle)
                          ),
                          _vm._m(12, true)
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "info" }, [
                        _c("em", { staticClass: "info_category" }, [
                          _c(
                            "a",
                            {
                              staticClass: "textcolor_must",
                              attrs: { href: cont.linkUrl, target: "_blank" }
                            },
                            [_vm._v(_vm._s(cont.linkUrl))]
                          )
                        ])
                      ])
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.dtcmTotalCount > 0
                  ? _c("div", { staticClass: "btn_wrap" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_laodmore",
                          attrs: { href: "JavaScript:" },
                          on: {
                            click: function($event) {
                              return _vm.getSamsungDotCom(_vm.dtcmPage)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.dtcmMoreMsg) +
                              "\n                            "
                          ),
                          _vm.dtcmTotalCount > 0
                            ? _c("em", [
                                _vm._v("("),
                                _c("i", [
                                  _vm._v(_vm._s(_vm.dtcmContents.length))
                                ]),
                                _vm._v("/" + _vm._s(_vm.dtcmTotalCount) + ")")
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dtcmTotalCount == 0
                  ? _c("ul", { staticClass: "nodata_list" }, [
                      _c("li", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { class: { active: _vm.toggle4 }, attrs: { "data-type": "qna" } },
            [
              _c("div", { staticClass: "result_title" }, [
                _c(
                  "em",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle4 = !_vm.toggle4
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SVCPARTNER")))]
                )
              ]),
              _vm._v(" "),
              _vm.toggle4
                ? _c("div", { staticClass: "result_con" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "knowledge_list" },
                      _vm._l(_vm.svcpContents, function(cont) {
                        return _c("li", { key: cont.keyId }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetailInfo($event, cont)
                                }
                              }
                            },
                            [
                              cont.iconType
                                ? _c(
                                    "em",
                                    { class: _vm.getIconClass(cont.iconType) },
                                    [_vm._v(_vm._s(cont.iconType))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.IMPORTANCE_YN == "Y"
                                ? _c(
                                    "em",
                                    { staticClass: "textcolor_important" },
                                    [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                          ) +
                                          "]"
                                      )
                                    ]
                                  )
                                : cont.MUST_READ_YN == "Y"
                                ? _c("em", { staticClass: "textcolor_must" }, [
                                    _vm._v(
                                      "[" +
                                        _vm._s(
                                          _vm.$t("FIELD.GLOBAL.MUSTREAD")
                                        ) +
                                        "]"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("em", {
                                domProps: { innerHTML: _vm._s(cont.subject) }
                              }),
                              _vm._v(" "),
                              _c("em", { staticClass: "info_modifi" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(cont.corpName) +
                                    ", " +
                                    _vm._s(cont.regDate) +
                                    ")"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon_item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "ico_favorite",
                                class: { off: !cont.isFavorite },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "F")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.FAVOR"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("BUTTON.FAST.FAVORITE")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "ico_like",
                                class: { off: !cont.isLike },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "L")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.LIKE"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.LIKE")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "info" }, [
                            _c("em", [_vm._v(_vm._s(cont.dispName))]),
                            _vm._v(" "),
                            _c("em", [_vm._v(_vm._s(cont.prodCd2))]),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.FAST.MODEL")) +
                                  " " +
                                  _vm._s(cont.modelNm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "hit" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.HIT"))),
                              _c("i", [_vm._v(_vm._s(cont.hitCnt))])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "view_desc" },
                            [
                              _c(
                                "table",
                                { staticClass: "data_table_ty2 mb-20" },
                                [
                                  _vm._m(14, true),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.REGISTERED.BY")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.REG_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.REG_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.MODIFY.USER")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.MODF_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.MODF_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.symptomList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.symptomList, function(
                                                symptom
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(symptom.NAME)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FIELD.KNOWLEDGE.MANUFACTURE"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.serialList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.serialList, function(
                                                serial
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(
                                                          serial.SERIAL_S
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            serial.SERIAL_E
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.GUIDETYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getGuideTypeName))
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getDefectTypeName))
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tab_wrap" }, [
                                _c(
                                  "ul",
                                  { staticClass: "tab_menu_02 tab_menus" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "on",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.DESCRIPTION"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.MODEL.LIST"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.PARTSLISTS"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.VERHISTORY"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "tab_contents" }, [
                                  _c("div", {
                                    staticClass: "tab_cont",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.KNOWLEDGE_DESC)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.resultCount < 999
                                    ? _c("div", { staticClass: "grid_total" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) +
                                            " : "
                                        ),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberFormat")(
                                                _vm.resultCount
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.modelGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.modelGridId + cont.keyId,
                                          data: _vm.modelList,
                                          columns: _vm.modelColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.partsGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.partsGridId + cont.keyId,
                                          data: _vm.partsList,
                                          columns: _vm.partsColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab_cont" }, [
                                    _c("table", { staticClass: "data_table" }, [
                                      _vm._m(15, true),
                                      _vm._v(" "),
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.VERSION"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("FIELD.GLOBAL.DATE")
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.EDITOR"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.DETAILS"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        { staticClass: "text_center" },
                                        _vm._l(_vm.versionList, function(
                                          version
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: version.VERSION_NO },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  "Ver." +
                                                    _vm._s(version.VERSION_NO)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_DT)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_USER)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text_left" },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        version.MODF_REASON
                                                      ) +
                                                      "\n                                                         "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.contAttaches &&
                              _vm.contAttaches.length > 0 &&
                              cont.active == cont.keyId
                                ? _c("innorix-download", {
                                    attrs: {
                                      uploadId: _vm.uploadId + cont.keyId,
                                      serviceType: _vm.serviceType,
                                      attachList: _vm.contAttaches,
                                      fixWidth: _vm.irxWidth
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.contAttaches.length > 0
                                ? _c("dl", { staticClass: "attachment_link" }, [
                                    _c("dt", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.contAttaches, function(
                                          file
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                file.ENC_ATTCH_FILE_SEQ +
                                                file.ENC_TOKEN
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownloadUrl(
                                                        file.ENC_ATTCH_FILE_SEQ,
                                                        file.ENC_TOKEN
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "ico_attach"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(file.FILE_NM) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btn_wrap text_center mt-40 pc_only"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn_white_ico",
                                      attrs: { href: "JavaScript:", title: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.btnPrint(
                                            _vm.detail.KNOWLEDGE_ID
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "ico_printer on"
                                      }),
                                      _vm._v("Print")
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.svcpTotalCount > 0
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_laodmore",
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.loadMoreCont(
                                    50,
                                    _vm.svcpTotalCount
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.svcpMoreMsg) +
                                  "\n                            "
                              ),
                              _vm.svcpTotalCount > 0
                                ? _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.svcpContents.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.svcpTotalCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.svcpTotalCount == 0
                      ? _c("ul", { staticClass: "nodata_list" }, [
                          _c("li", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { class: { active: _vm.toggle5 }, attrs: { "data-type": "qna" } },
            [
              _c("div", { staticClass: "result_title" }, [
                _c(
                  "em",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle5 = !_vm.toggle5
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY")))]
                )
              ]),
              _vm._v(" "),
              _vm.toggle5
                ? _c("div", { staticClass: "result_con" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "knowledge_list" },
                      _vm._l(_vm.subsContents, function(cont) {
                        return _c("li", { key: cont.keyId }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetailInfo($event, cont)
                                }
                              }
                            },
                            [
                              cont.iconType
                                ? _c(
                                    "em",
                                    { class: _vm.getIconClass(cont.iconType) },
                                    [_vm._v(_vm._s(cont.iconType))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              cont.IMPORTANCE_YN == "Y"
                                ? _c(
                                    "em",
                                    { staticClass: "textcolor_important" },
                                    [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                          ) +
                                          "]"
                                      )
                                    ]
                                  )
                                : cont.MUST_READ_YN == "Y"
                                ? _c("em", { staticClass: "textcolor_must" }, [
                                    _vm._v(
                                      "[" +
                                        _vm._s(
                                          _vm.$t("FIELD.GLOBAL.MUSTREAD")
                                        ) +
                                        "]"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("em", {
                                domProps: { innerHTML: _vm._s(cont.subject) }
                              }),
                              _vm._v(" "),
                              _c("em", { staticClass: "info_modifi" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(cont.corpName) +
                                    ", " +
                                    _vm._s(cont.regDate) +
                                    ")"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "icon_item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "ico_favorite",
                                class: { off: !cont.isFavorite },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "F")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.FAVOR"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("BUTTON.FAST.FAVORITE")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "ico_like",
                                class: { off: !cont.isLike },
                                attrs: { href: "JavaScript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addFavorite($event, cont, "L")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tooltip2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("MESSAGE.GLOBAL.ADD.LIKE"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr_only" }, [
                                  _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.LIKE")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "info" }, [
                            _c("em", [_vm._v(_vm._s(cont.dispName))]),
                            _vm._v(" "),
                            _c("em", [_vm._v(_vm._s(cont.prodCd2))]),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.FAST.MODEL")) +
                                  " " +
                                  _vm._s(cont.modelNm)
                              )
                            ]),
                            _vm._v(" "),
                            _c("em", { staticClass: "hit" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.HIT"))),
                              _c("i", [_vm._v(_vm._s(cont.hitCnt))])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "view_desc" },
                            [
                              _c(
                                "table",
                                { staticClass: "data_table_ty2 mb-20" },
                                [
                                  _vm._m(17, true),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.REGISTERED.BY")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.REG_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.REG_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.MODIFY.USER")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "ul",
                                          { staticClass: "in_dotlist" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.MODF_USER) +
                                                " (" +
                                                _vm._s(_vm.detail.MODF_DT) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.symptomList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.symptomList, function(
                                                symptom
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(symptom.NAME)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FIELD.KNOWLEDGE.MANUFACTURE"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.serialList.length === 0
                                            ? _c(
                                                "ul",
                                                { staticClass: "in_dotlist" },
                                                [_c("li", [_vm._v(" ")])]
                                              )
                                            : _vm._l(_vm.serialList, function(
                                                serial
                                              ) {
                                                return _c(
                                                  "ul",
                                                  { staticClass: "in_dotlist" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        _vm._s(
                                                          serial.SERIAL_S
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            serial.SERIAL_E
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              })
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.GUIDETYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getGuideTypeName))
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text_left" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.getDefectTypeName))
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tab_wrap" }, [
                                _c(
                                  "ul",
                                  { staticClass: "tab_menu_02 tab_menus" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "on",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.DESCRIPTION"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.GLOBAL.MODEL.LIST"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.PARTSLISTS"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab($event, cont)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "FIELD.KNOWLEDGE.VERHISTORY"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "tab_contents" }, [
                                  _c("div", {
                                    staticClass: "tab_cont",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.KNOWLEDGE_DESC)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.resultCount < 999
                                    ? _c("div", { staticClass: "grid_total" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) +
                                            " : "
                                        ),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberFormat")(
                                                _vm.resultCount
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.modelGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.modelGridId + cont.keyId,
                                          data: _vm.modelList,
                                          columns: _vm.modelColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tab_cont" },
                                    [
                                      _c("toast-grid", {
                                        ref: _vm.partsGridId + cont.keyId,
                                        refInFor: true,
                                        attrs: {
                                          gridId: _vm.partsGridId + cont.keyId,
                                          data: _vm.partsList,
                                          columns: _vm.partsColumns,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab_cont" }, [
                                    _c("table", { staticClass: "data_table" }, [
                                      _vm._m(18, true),
                                      _vm._v(" "),
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.VERSION"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("FIELD.GLOBAL.DATE")
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pc_only",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.EDITOR"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.DETAILS"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        { staticClass: "text_center" },
                                        _vm._l(_vm.versionList, function(
                                          version
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: version.VERSION_NO },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  "Ver." +
                                                    _vm._s(version.VERSION_NO)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_DT)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pc_only" },
                                                [
                                                  _vm._v(
                                                    _vm._s(version.MODF_USER)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text_left" },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        version.MODF_REASON
                                                      ) +
                                                      "\n                                                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.contAttaches &&
                              _vm.contAttaches.length > 0 &&
                              cont.active == cont.keyId
                                ? _c("innorix-download", {
                                    attrs: {
                                      uploadId: _vm.uploadId + cont.keyId,
                                      serviceType: _vm.serviceType,
                                      attachList: _vm.contAttaches,
                                      fixWidth: _vm.irxWidth
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.contAttaches.length > 0
                                ? _c("dl", { staticClass: "attachment_link" }, [
                                    _c("dt", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.contAttaches, function(
                                          file
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                file.ENC_ATTCH_FILE_SEQ +
                                                file.ENC_TOKEN
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownloadUrl(
                                                        file.ENC_ATTCH_FILE_SEQ,
                                                        file.ENC_TOKEN
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "ico_attach"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(file.FILE_NM) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btn_wrap text_center mt-40 pc_only"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn_white_ico",
                                      attrs: { href: "JavaScript:", title: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.btnPrint(
                                            _vm.detail.KNOWLEDGE_ID
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "ico_printer on"
                                      }),
                                      _vm._v("Print")
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.subsTotalCount > 0
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_laodmore",
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.loadMoreCont(
                                    60,
                                    _vm.subsTotalCount
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.subsMoreMsg) +
                                  "\n                            "
                              ),
                              _vm.subsTotalCount > 0
                                ? _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.subsContents.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.subsTotalCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.subsTotalCount == 0
                      ? _c("ul", { staticClass: "nodata_list" }, [
                          _c("li", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { class: { active: _vm.toggle6 }, attrs: { "data-type": "qna" } },
            [
              _c("div", { staticClass: "result_title" }, [
                _c(
                  "em",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggle6 = !_vm.toggle6
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA")))]
                )
              ]),
              _vm._v(" "),
              _vm.toggle6
                ? _c("div", { staticClass: "result_con" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "qna_result_list" },
                      _vm._l(_vm.qnaaContents, function(cont) {
                        return _c("li", { key: cont.keyId }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.showQnaInfo($event, cont)
                                }
                              }
                            },
                            [
                              _c("span", [
                                cont.iconType
                                  ? _c(
                                      "em",
                                      {
                                        class: _vm.getIconClass(cont.iconType)
                                      },
                                      [_vm._v(_vm._s(cont.iconType))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                cont.IMPORTANCE_YN == "Y"
                                  ? _c(
                                      "em",
                                      { staticClass: "textcolor_important" },
                                      [
                                        _vm._v(
                                          "[" +
                                            _vm._s(
                                              _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                            ) +
                                            "]"
                                        )
                                      ]
                                    )
                                  : cont.MUST_READ_YN == "Y"
                                  ? _c(
                                      "em",
                                      { staticClass: "textcolor_must" },
                                      [
                                        _vm._v(
                                          "[" +
                                            _vm._s(
                                              _vm.$t("FIELD.GLOBAL.MUSTREAD")
                                            ) +
                                            "]"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("em", {
                                  domProps: { innerHTML: _vm._s(cont.subject) }
                                })
                              ]),
                              _vm._v(" "),
                              _c("i", [
                                _vm._v(
                                  _vm._s(cont.regUser) +
                                    " (" +
                                    _vm._s(cont.regDate) +
                                    ")"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "conts" },
                            [
                              _c("div", { staticClass: "q_cont" }, [
                                _c("div", {
                                  key: _vm.qnaInfo.questionId,
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.stripHtml(_vm.QNA_DESCR)
                                    )
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _vm.QST_ATTACHES &&
                              _vm.QST_ATTACHES.length > 0 &&
                              cont.active == cont.keyId
                                ? _c("innorix-download", {
                                    attrs: {
                                      uploadId: _vm.uploadId + cont.keyId,
                                      serviceType: _vm.serviceType,
                                      attachList: _vm.QST_ATTACHES,
                                      fixWidth: _vm.irxWidth
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.QST_ATTACHES.length > 0
                                ? _c("dl", { staticClass: "attachment_link" }, [
                                    _c("dt", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.QST_ATTACHES, function(
                                          file
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                file.ENC_ATTCH_FILE_SEQ +
                                                file.ENC_TOKEN
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "txt_link",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownloadUrl(
                                                        file.ENC_ATTCH_FILE_SEQ,
                                                        file.ENC_TOKEN
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "ico_attach"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(file.FILE_NM) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.QNA_REPLY
                                ? _c(
                                    "div",
                                    { staticClass: "a_cont" },
                                    [
                                      _c("div", {
                                        staticClass: "namo_scrollbar",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.stripHtml(_vm.QNA_REPLY)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.ANS_ATTACHES &&
                                      _vm.ANS_ATTACHES.length > 0 &&
                                      cont.active == cont.keyId
                                        ? _c("innorix-download", {
                                            attrs: {
                                              uploadId:
                                                _vm.uploadId + cont.keyId,
                                              serviceType: _vm.serviceType,
                                              attachList: _vm.ANS_ATTACHES,
                                              fixWidth: _vm.irxWidth
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.ANS_ATTACHES.length > 0
                                        ? _c(
                                            "dl",
                                            { staticClass: "attachment_link" },
                                            [
                                              _c("dt", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "txt_link",
                                                    attrs: {
                                                      href: "javascript:"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleLink(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MESSAGE.GLOBAL.TROUBLE.DOWN"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    _vm.ANS_ATTACHES,
                                                    function(file) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key:
                                                            file.ENC_ATTCH_FILE_SEQ +
                                                            file.ENC_TOKEN
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "txt_link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.getDownloadUrl(
                                                                    file.ENC_ATTCH_FILE_SEQ,
                                                                    file.ENC_TOKEN
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "ico_attach"
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    file.FILE_NM
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.qnaaTotalCount > 0
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_laodmore",
                              attrs: { href: "JavaScript:" },
                              on: {
                                click: function($event) {
                                  return _vm.loadMoreCont(
                                    20,
                                    _vm.qnaaTotalCount
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.qnaaMoreMsg) +
                                  "\n                            "
                              ),
                              _vm.qnaaTotalCount > 0
                                ? _c("em", [
                                    _vm._v("("),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.qnaaContents.length))
                                    ]),
                                    _vm._v(
                                      "/" + _vm._s(_vm.qnaaTotalCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.qnaaTotalCount == 0
                      ? _c("ul", { staticClass: "nodata_list" }, [
                          _c("li", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box quick_downs",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "70%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn_wrap" }, [
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("Deju Vu")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/isoview7.cab",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("iso View")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_engine",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { align: "center", width: "20%" } }),
      _vm._v(" "),
      _c("col", {
        staticClass: "pc_only",
        attrs: { align: "center", width: "30%" }
      }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { align: "center", width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_engine",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { align: "center", width: "20%" } }),
      _vm._v(" "),
      _c("col", {
        staticClass: "pc_only",
        attrs: { align: "center", width: "30%" }
      }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { align: "center", width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_dotcom",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ico_link" }, [
      _c("span", { staticClass: "sr_only" }, [_vm._v("new window")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_engine",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { align: "center", width: "20%" } }),
      _vm._v(" "),
      _c("col", {
        staticClass: "pc_only",
        attrs: { align: "center", width: "30%" }
      }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { align: "center", width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_engine",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { align: "center", width: "20%" } }),
      _vm._v(" "),
      _c("col", {
        staticClass: "pc_only",
        attrs: { align: "center", width: "30%" }
      }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { align: "center", width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "loader_box srch_engine",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loader" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-009706d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-009706d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/intgSearch/SearchList.vue
// module id = tjF5
// module chunks = 0